<template>
    <ModalComponent
        name="CreateVoucher"
        title="Nuevo Cupón"
        v-on:close="close"
    >
        <FormVoucher :voucher="data" :session_id="session_id" :event_id="event_id" />

        <div slot="footer">
            <Button type="button" class="mr-3" @click="create" :disabled="loading" id="guardar-cupon">GUARDAR</Button>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormVoucher from "@/components/backend/eventos/FormVoucher";

    export default {
        props: ['event_id', 'session_id'],
        data() {
            return {
                loading: false,
                data: { units: 1, code: this.randomCode(), discount_fixed: 0, discount_percent: 0, event_id: this.event_id, session_id: this.session_id }
            }
        },
        methods: {
            create() {
                const params = {
                    filters : {},
                    voucher: this.data,
                    event_id: this.event_id,
                    session_id: this.session_id
                };
                
                this.$store.dispatch(this.config.getVuexAlias('back.events.voucher.create'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);

                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.close();
                }).finally(() => this.loading = false);
            },
            close(editado = false) {
                this.$emit('close', 'CreateVoucher', editado);
            },
            randomCode() {
                return [...crypto.getRandomValues(new Uint8Array(4))].map(m=>('0'+m.toString(16)).slice(-2)).join('').toUpperCase();
            }
        },
        components: {
            ModalComponent, FormVoucher
        }
    }
</script>
